import { Plan, PlanPrice, CorePlanTier, PrepaidCreditPack, PrepaidPackDefinition } from "../types";
import { STANDARD_PRICE_PER_CREDIT_USD } from "./ubp";

export const CORE_PLAN_TIERS: CorePlanTier[] = [
    {
        credits: 15,
        monthlyPrice: 99,
        annualPrice: 79,
        monthlyDiscountPercent: 0,
        annualDiscountPercent: 0,
        isDefaultForPersonalUsers: true
    },
    {
        credits: 50,
        monthlyPrice: 229,
        annualPrice: 199,
        monthlyDiscountPercent: 8,
        annualDiscountPercent: 15,
        isDefault: true
    },
    {
        credits: 100,
        monthlyPrice: 399,
        annualPrice: 359,
        monthlyDiscountPercent: 12,
        annualDiscountPercent: 18
    },
    {
        credits: 200,
        monthlyPrice: 729,
        annualPrice: 669,
        monthlyDiscountPercent: 15,
        annualDiscountPercent: 20
    }
];

const defaultCoreTier = CORE_PLAN_TIERS.find((t) => t.isDefault) || CORE_PLAN_TIERS[0];

export const PLAN_PRICING: Record<Plan, PlanPrice> = {
    [Plan.Public]: { monthly: "Free", annual: "Free" },
    [Plan.UbpBasic]: { monthly: 65, annual: 49 },
    [Plan.UbpCore]: { monthly: defaultCoreTier.monthlyPrice, annual: defaultCoreTier.annualPrice },
    [Plan.UbpGrowth]: { monthly: 399, annual: 299 },
    [Plan.UbpPremiumTrial]: { monthly: 399, annual: 299 },
    [Plan.EnterpriseGrowth]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.Enterprise]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.LegacySandbox]: { monthly: "Free", annual: "Free" },
    [Plan.LegacyStarter]: { monthly: 249, annual: 200 },
    [Plan.Research]: { monthly: "Free", annual: "Free" },
    [Plan.UninitalizedWorkspace]: { monthly: "N/A", annual: "N/A" }
} as any;

export const PREPAID_PACK_DEFINITIONS: Record<"core" | "public", PrepaidPackDefinition[]> = {
    core: [
        { credits: 15, discountPercent: 0 },
        { credits: 50, discountPercent: 7.5 },
        { credits: 100, discountPercent: 12 },
        { credits: 200, discountPercent: 14.75 },
        { credits: 600, discountPercent: 17 }
    ],
    public: [
        { credits: 15, discountPercent: 0 },
        { credits: 50, discountPercent: 5 },
        { credits: 100, discountPercent: 7 },
        { credits: 200, discountPercent: 9 },
        { credits: 600, discountPercent: 11 }
    ]
};

function buildPack(def: PrepaidPackDefinition, basePricePerCredit: number): PrepaidCreditPack {
    const effectiveRate =
        Math.round(basePricePerCredit * (1 - def.discountPercent / 100) * 100) / 100;
    return {
        credits: def.credits,
        pricePerCredit: effectiveRate,
        totalPrice: Math.round(def.credits * effectiveRate * 100) / 100,
        discountPercent: def.discountPercent
    };
}

export function computePrepaidCreditPacks(
    basePricePerCredit: number,
    planCategory: "core" | "public" = "core"
): PrepaidCreditPack[] {
    return PREPAID_PACK_DEFINITIONS[planCategory].map((def) => buildPack(def, basePricePerCredit));
}

export const PREPAID_CREDIT_PACKS: Record<"core" | "public", PrepaidCreditPack[]> = {
    core: computePrepaidCreditPacks(STANDARD_PRICE_PER_CREDIT_USD, "core"),
    public: computePrepaidCreditPacks(STANDARD_PRICE_PER_CREDIT_USD, "public")
};
